export default "__VITE_ASSET__CsInL0oR__"